import React, { FunctionComponent, PropsWithChildren } from 'react';

import { Button } from '@yandex-360/orb-components/dist/components/Button';
import * as OrbModal from '@yandex-360/orb-components/dist/components/Modal2';
import { ModalProps } from '@yandex-360/orb-components/dist/components/Modal2';

export type ModalConfirmPureProps = PropsWithChildren<
    Pick<ModalProps, 'size' | 'visible'> &
        Pick<OrbModal.NavigationBarProps, 'title' | 'titleLineLimit' | 'closable'> & {
            confirmLabel: string;
            cancelLabel: string;
            onConfirm: () => void;
            onCancel: () => void;
            onClose: () => void;
        }
>;

export const ModalConfirmPure: FunctionComponent<ModalConfirmPureProps> = ({
    title,
    confirmLabel,
    cancelLabel,
    onConfirm,
    onCancel,
    children,
    onClose,
    titleLineLimit = 3,
    ...modalProps
}) => {
    return (
        <OrbModal.Modal onClose={onClose} {...modalProps}>
            <OrbModal.NavigationBar titleLineLimit={titleLineLimit} title={title} closable />
            <OrbModal.Slot>{children}</OrbModal.Slot>
            <OrbModal.ActionBar>
                <Button view="neutral" onPress={onCancel}>
                    {cancelLabel}
                </Button>
                <Button view="brand" onPress={onConfirm}>
                    {confirmLabel}
                </Button>
            </OrbModal.ActionBar>
        </OrbModal.Modal>
    );
};
